import React, { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

/* Lucky page: consecutive-slot streak → free-ticket bonus progress (refreshes after each booking). */
export function StreakChip({ gameId, lang }) {
  const { user } = useAuth();
  const [st, setSt] = useState(null);
  useEffect(() => {
    if (!user || !gameId) return;
    const load = () => api.get(`/bets/streak/${gameId}`).then((r) => setSt(r.data)).catch(() => {});
    load();
    window.addEventListener("rl-bets-placed", load);
    return () => window.removeEventListener("rl-bets-placed", load);
  }, [user, gameId]);
  if (!st || !st.enabled) return null;
  const full = st.progress >= st.need;
  return (
    <div className={`rounded-2xl px-3.5 py-2.5 flex items-center gap-3 border ${full ? "bg-orange-500 border-orange-400 text-white" : "bg-orange-50 border-orange-200 text-orange-900"}`} data-testid="streak-chip">
      <Flame className={`w-6 h-6 shrink-0 ${full ? "text-white animate-pulse" : "text-orange-500"}`} />
      <div className="flex-1 min-w-0">
        <div className="text-xs font-black" data-testid="streak-title">
          {full ? (lang === "ta" ? `🔥 ${st.run}-slot streak! ₹${st.bonus} free ticket சேர்ந்தது` : `🔥 ${st.run}-slot streak! ₹${st.bonus} free ticket added`)
            : (lang === "ta" ? `தொடர்ந்து ${st.need} slots book பண்ணுங்க → ₹${st.bonus} free ticket` : `Book ${st.need} slots in a row → ₹${st.bonus} free ticket`)}
        </div>
        <div className="flex items-center gap-1 mt-1">
          {Array.from({ length: st.need }).map((_, i) => <span key={i} className={`h-1.5 flex-1 rounded-full ${i < st.progress ? (full ? "bg-white" : "bg-orange-500") : "bg-orange-200/70"}`} />)}
          <span className="text-[10px] font-bold ml-1" data-testid="streak-progress">{st.progress}/{st.need}</span>
        </div>
        {!full && st.run > 0 && <div className="text-[10px] mt-0.5 opacity-80">{lang === "ta" ? `இன்னும் ${st.to_next} slot(s) · ஒரு slot விட்டா streak reset` : `${st.to_next} more slot(s) · skipping a slot resets the streak`}</div>}
      </div>
    </div>
  );
}
